export default "__VITE_ASSET__12f26887__"